import { AppShell } from '@mantine/core';
import { AnimatePresence } from 'motion/react';
import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import eterno_logo from '@/assets/logo.svg';

import { FeatureErrorBoundary } from '@/components/feature-error-boundary.tsx';
import { HeaderNavigation } from '@/components/header-navigation.tsx';
import { UserMenu } from '@/components/user-menu.tsx';

import { AppRoute } from '@/constants/app-routes.ts';

import { useConfig } from '@/hooks/use-config.ts';

interface Props {
    children: ReactNode;
}

export const OfficeAppShell = ({ children }: Props) => {
    const { selectedCustomer } = useConfig();
    // const [mobile_opened, { toggle: toggleMobile }] = useDisclosure();
    // const [desktop_opened, { toggle: toggleDesktop }] = useDisclosure(true);

    // const filtered_routes = useMemo(() => {
    //     return authenticated_routes.filter((route) => route.name && route.key);
    // }, []);

    // TEMPORARY COMMENTED OUT CODE FOR SIDE MENU

    return (
        <AnimatePresence mode="wait">
            <AppShell
                header={{ height: 60 }}
                // navbar={{
                //     width: 300,
                //     breakpoint: 'sm',
                //     collapsed: { mobile: !mobile_opened, desktop: !desktop_opened },
                // }}
                className="bg-slate-100 dark:bg-transparent"
            >
                <AppShell.Header>
                    <div className="flex h-full items-center justify-between px-10">
                        <div className="flex h-full items-center gap-6">
                            {/* TEMPORARY DISABLED SIDE MENU  */}

                            {/* <Burger opened={mobile_opened} onClick={toggleMobile} className="block size-8 sm:hidden" />
                            <Burger
                                opened={desktop_opened}
                                onClick={toggleDesktop}
                                className="hidden size-8 sm:block"
                            /> */}

                            <Link to={AppRoute.ROOT}>
                                <img
                                    src={selectedCustomer?.customer_icon_large?.url ?? eterno_logo}
                                    alt={selectedCustomer?.customer_name ?? 'eterno'}
                                    className="h-8 max-w-[10rem] object-contain"
                                />
                            </Link>
                            {/*<CustomerPracticeSelection />*/}
                        </div>

                        <div className="flex items-center gap-8">
                            <FeatureErrorBoundary featureName="header-navigation">
                                <HeaderNavigation />
                            </FeatureErrorBoundary>
                            <FeatureErrorBoundary featureName="user-menu">
                                <UserMenu />
                            </FeatureErrorBoundary>
                        </div>
                    </div>
                </AppShell.Header>
                {/* <AppShell.Navbar className="p-2">
                    {filtered_routes.map((route) => (
                        <NavLink key={route.key} href={route.path} label={route.name} leftSection={route.icon} />
                    ))}
                </AppShell.Navbar> */}
                <AppShell.Main
                    classNames={{
                        main: 'flex min-h-svh flex-col',
                    }}
                >
                    {children}
                </AppShell.Main>
            </AppShell>
        </AnimatePresence>
    );
};
